'use es6';

window.I18n = window.I18n || {};
export default window.I18n;